import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { useDropzone } from "react-dropzone"

import { NOOP } from "@fedsim/helpers"
import { importData } from "@fedsim/actions"

const useLoadGame = ({ onComplete = NOOP }) => {
  const dispatch = useDispatch()
  const onDrop = useCallback(
    acceptedFiles => {
      const reader = new FileReader()

      reader.onabort = () => console.error("file reading was aborted")
      reader.onerror = () => console.error("file reading has failed")
      reader.onload = () => {
        const actions = JSON.parse(reader.result)
        for (let { type, payload } of actions) {
          dispatch(importData({ type, payload }))
        }
      }

      acceptedFiles.forEach(file => reader.readAsBinaryString(file))
      onComplete()
    },
    [dispatch, onComplete]
  )
  return useDropzone({ onDrop })
}

export default useLoadGame
